module.exports = __webpack_public_path__ + "media/mypage/images/750x90-781ce5e039e651f387f891633f83d224.jpg";